"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCouponList = getCouponList;
exports.getFucardList = getFucardList;
exports.getMiniappList = getMiniappList;
exports.getStoreListBySupplierId = getStoreListBySupplierId;
exports.instantDiscountAutoList = instantDiscountAutoList;
exports.instantDiscountDelete = instantDiscountDelete;
exports.instantDiscountInfo = instantDiscountInfo;
exports.instantDiscountList = instantDiscountList;
exports.instantDiscountOpLogInfo = instantDiscountOpLogInfo;
exports.instantDiscountOpLogList = instantDiscountOpLogList;
exports.instantDiscountSave = instantDiscountSave;
exports.instantDiscountUpdate = instantDiscountUpdate;
exports.instantDiscountUpdateStatus = instantDiscountUpdateStatus;
exports.supplierList = supplierList;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 立减活动列表
 * @param pram
 * @returns
 */
function instantDiscountList() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = pram || {},
    activityName = _ref.activityName,
    marketer = _ref.marketer,
    activityType = _ref.activityType,
    supplierId = _ref.supplierId,
    status = _ref.status,
    fuCardId = _ref.fuCardId,
    supportThirdParty = _ref.supportThirdParty,
    customerId = _ref.customerId,
    page = _ref.page,
    limit = _ref.limit;
  return (0, _request.default)({
    url: '/admin/instant/discount/list',
    method: 'GET',
    params: {
      activityName: activityName,
      marketer: marketer,
      activityType: activityType,
      supplierId: supplierId,
      status: status,
      fuCardId: fuCardId,
      supportThirdParty: supportThirdParty,
      customerId: customerId,
      page: page,
      limit: limit
    }
  });
}

/**
 * 立减活动详情
 * @param id
 * @returns
 */
function instantDiscountInfo(id) {
  return (0, _request.default)({
    url: '/admin/instant/discount/info',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 新建立减活动
 * @param data
 * @returns
 */
function instantDiscountSave(data) {
  return (0, _request.default)({
    url: '/admin/instant/discount/save',
    method: 'POST',
    data: data
  });
}

/**
 * 更新立减活动
 * @param data
 * @returns
 */
function instantDiscountUpdate(data) {
  return (0, _request.default)({
    url: '/admin/instant/discount/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除立减活动
 * @param id
 * @returns
 */
function instantDiscountDelete(id) {
  return (0, _request.default)({
    url: '/admin/instant/discount/delete',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 更新立减活动状态
 * @param data
 * @returns
 */
function instantDiscountUpdateStatus(data) {
  return (0, _request.default)({
    url: '/admin/instant/discount/updateStatus',
    method: 'POST',
    data: data
  });
}

/**
 * 立减活动自动补全列表
 * @param keyword
 * @returns
 */
function instantDiscountAutoList(keyword) {
  return (0, _request.default)({
    url: '/admin/instant/discount/autoList',
    method: 'GET',
    params: {
      keyword: keyword
    }
  });
}

/**
 * 供应商列表（核销供应商）
 * @param {string} keyword - 搜索关键词
 * @returns
 */
function supplierList(keyword) {
  return (0, _request.default)({
    url: '/admin/business/supplier/autoListByType',
    method: 'GET',
    params: {
      type: 4,
      keyword: keyword || ''
    }
  });
}

/**
 * 小程序列表
 * @param {string} keyword - 搜索关键词
 * @returns
 */
function getMiniappList(keyword) {
  return (0, _request.default)({
    url: '/admin/companyapp/autoList',
    method: 'GET',
    params: {
      keyword: keyword || ''
    }
  });
}

/**
 * 福卡列表（支付方式）
 * @param {string} keyword - 搜索关键词
 * @returns
 */
function getFucardList(keyword) {
  return (0, _request.default)({
    url: '/admin/fudou/fucard/select',
    method: 'GET',
    params: {
      keyword: keyword || ''
    }
  });
}

/**
 * 优惠券下拉列表（用于叠加优惠券下拉选，按名称模糊匹配）
 * 调用后端 GET /api/admin/coupons/opitionList，参数 name(可选)
 * @param {string} keyword - 搜索关键词
 * @returns {Promise<Array<{id:number,name:string}>>}
 */
function getCouponList(keyword) {
  return (0, _request.default)({
    url: '/admin/coupons/opitionList',
    method: 'GET',
    params: {
      name: keyword || ''
    }
  });
}

/**
 * 立减活动-操作日志分页列表
 * @param {object} pram { activityId, opType, startTime, endTime, page, limit }
 */
function instantDiscountOpLogList() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = pram || {},
    activityId = _ref2.activityId,
    opType = _ref2.opType,
    startTime = _ref2.startTime,
    endTime = _ref2.endTime,
    page = _ref2.page,
    limit = _ref2.limit;
  return (0, _request.default)({
    url: '/admin/instant/discount/opLog/list',
    method: 'GET',
    params: {
      activityId: activityId,
      opType: opType,
      startTime: startTime,
      endTime: endTime,
      page: page,
      limit: limit
    }
  });
}

/**
 * 立减活动-操作日志详情
 * @param {number} id 日志ID
 */
function instantDiscountOpLogInfo(id) {
  return (0, _request.default)({
    url: '/admin/instant/discount/opLog/info',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 根据供应商ID获取门店下拉列表（复用autoList接口）
 * @param {number} supplierId - 供应商ID
 * @param {string} keyword - 搜索关键词（可选）
 * @returns {Promise<Array<{id:number,name:string}>>}
 */
function getStoreListBySupplierId(supplierId) {
  var keyword = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (0, _request.default)({
    url: '/admin/offlineStore/autoList',
    method: 'GET',
    params: {
      offlineSupplierId: supplierId,
      keyword: keyword
    }
  });
}